// frontend/src/services/userService.ts
import { User, Tag } from '@/types';
import { apiClient } from './api'; // Cambiar de './api' a './api' si es necesario

export interface UserPreferencesRequest {
    allergies: string[];
    dislikedIngredients: string[];
    weightGoal: 'LOSE' | 'MAINTAIN' | 'GAIN';
    nutritionalPreferences: Tag[];
    age?: number;
    height?: number;
    weight?: number;
    gender?: string;
    activityLevel?: string;
    recommendedCalories?: number;
}

export const userService = {
    // Obtener perfil del usuario
    async getProfile(token: string): Promise<User> {
        const response = await apiClient.get('/users/profile', token);
        return response.data;
    },

    // Actualizar preferencias del usuario
    // async updatePreferences(preferences: UserPreferencesRequest, token: string): Promise<User> {
    //     const response = await apiClient.put('/users/preferences', preferences, token);
    //     return response.data;
    // },

    // Actualizar preferencias dietéticas
    async updateDietaryPreferences(preferences: Tag[], token: string): Promise<User> {
        const response = await apiClient.put('/users/dietary-preferences', preferences, token);
        return response.data;
    },

    // Actualizar ingredientes excluidos
    async updateExcludedIngredients(ingredients: string[], token: string): Promise<User> {
        const response = await apiClient.put('/users/excluded-ingredients', ingredients, token);
        return response.data;
    },


    async getCompleteProfile(token: string): Promise<User> {
        const response = await apiClient.get('/users/profile', token);
        return response;
    },

    async updatePreferences(token: string, preferences: any): Promise<void> {
        await apiClient.put('/users/preferences', preferences, token);

        // Disparar evento para que las recomendaciones se actualicen
        window.dispatchEvent(new Event('preferencesUpdated'));
    }
};